import React from "react";
import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  // generic
  draft: "bg-slate-100 text-slate-600 border-slate-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  open: "bg-blue-50 text-blue-700 border-blue-200",
  closed: "bg-slate-100 text-slate-600 border-slate-200",
  verified: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
  suspended: "bg-rose-50 text-rose-700 border-rose-200",
  under_review: "bg-indigo-50 text-indigo-700 border-indigo-200",
  clarification: "bg-amber-50 text-amber-700 border-amber-200",
  shortlisted: "bg-violet-50 text-violet-700 border-violet-200",
  awarded: "bg-emerald-50 text-emerald-700 border-emerald-200",
  expired: "bg-slate-100 text-slate-500 border-slate-200",
  // submissions
  submitted: "bg-blue-50 text-blue-700 border-blue-200",
  interview: "bg-indigo-50 text-indigo-700 border-indigo-200",
  selected: "bg-emerald-50 text-emerald-700 border-emerald-200",
  offer: "bg-teal-50 text-teal-700 border-teal-200",
  bgv: "bg-amber-50 text-amber-700 border-amber-200",
  joined: "bg-emerald-50 text-emerald-700 border-emerald-200",
  deployed: "bg-vs-light text-vs-royal border-blue-200",
  withdrawn: "bg-slate-100 text-slate-500 border-slate-200",
  sourced: "bg-slate-100 text-slate-600 border-slate-200",
  screened: "bg-blue-50 text-blue-700 border-blue-200",
  // finance
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partially_paid: "bg-amber-50 text-amber-700 border-amber-200",
  overdue: "bg-rose-50 text-rose-700 border-rose-200",
  issued: "bg-blue-50 text-blue-700 border-blue-200",
  acknowledged: "bg-indigo-50 text-indigo-700 border-indigo-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  expiring: "bg-amber-50 text-amber-700 border-amber-200",
  renewed: "bg-teal-50 text-teal-700 border-teal-200",
  terminated: "bg-rose-50 text-rose-700 border-rose-200",
  // tickets
  in_progress: "bg-indigo-50 text-indigo-700 border-indigo-200",
  waiting: "bg-amber-50 text-amber-700 border-amber-200",
  resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function StatusBadge({ status, className }) {
  if (!status) return <span className="text-slate-400 text-xs">—</span>;
  const key = String(status).toLowerCase();
  const style = STATUS_STYLES[key] || "bg-slate-100 text-slate-600 border-slate-200";
  const label = key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap", style, className)}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />{label}
    </span>
  );
}

export function VerificationBadge({ status }) {
  return <StatusBadge status={status} />;
}
